<template>
  <div class="row newsletter no-gutters w-100 innerbox-black gtm-onElementVisiblity"
       :class="[{'hidden-overflow':submit}]"
       gtm-on="elementVisibility"
       :gtm-visibility-category="gtmNewsletterCategory"
       gtm-visibility-action="Newsletter widget impression"
       :gtm-visibility-label="newsletterType.name"
       v-if="showNewsletter"
       :style="{height: newsletterWrapperHeight}"
       >
    <resize-observer @notify="onResize" />

    <!-- newletter first stage start -->
    <!-- newsletter-form-start -->

    <transition name="newsletter-form-transition" enter-active-class="animated-submit-form fadeInUp" appear>
      <div class="newsletter-form" v-if="!submit">
        <form @submit.prevent="onSubmit" class="mx-auto" novalidate>
          <div class="row justify-content-center no-gutters" :class="[{'active':submit}]">
            <div class="col-7 form-input">
              <input type="email" class="w-100 form-control border-0 pl-2 pr-2 input-email" :class="{'warning-color': warning }" v-model.trim="monsterEmail"
                     placeholder="your email">
            </div>
            <div class="col-4 form-btn">
              <span class="input-group-btn">
                <button class="btn submit-newsletter pl-0 pr-0" type="submit">
                  <span>SIGN UP</span>
                </button>
              </span>
            </div>
          </div>
          <div class="notification warning" :class="{'warning-color': warning }">
            <div class="d-flex align-items-center pr-3 pl-3 h-100" v-if="warning">Email Address is not valid.</div>
          </div>
        </form>
      </div>
    </transition>

    <!-- diamond shape icon with email start  -->
    <transition name="newsletter-form-transition" enter-active-class="animated-submit-form fadeIn" appear>
      <div class="diamond-icon" v-if="!submit">
        <svg-diamond-shape-icon></svg-diamond-shape-icon>
      </div>
    </transition>
    <!-- end newsletter-text-box -->
    <transition @after-enter="animation('add')" @leave="animation('remove')" appear>
      <div class="col-12 newsletter-inner-wrapper" v-if="!submit">
        <div ref="innerbox-0" class="innerbox first" :class="newsletterType.color">
          <div ref="innerbox-1" class="innerbox second" :class="newsletterType.color">
            <div ref="innerbox-2" class="innerbox third" :class="newsletterType.color">
              <div ref="innerbox-3" class="innerbox forth" :class="newsletterType.color">
                <div ref="innerbox-4" class="innerbox fifth" :class="newsletterType.color">
                  <div class=" w-100">
                    <div ref="newsletterTextBox" class="w-100 newsletter-text-box d-flex align-items-center"
                         v-if="!submit">
                      <div class="row no-gutters newsletter w-100 justify-content-center">
                        <div class="col-12 newsletter-text-content-wrapper">
                          <div class="text-wrapper">
                            <p class="title brand-title">GET OUR</p>
                          </div>
                          <div class="text-wrapper">
                            <p class="title">
                              <span class="section-type" :class="newsletterType.color">{{newsletterType.name}}</span>
                            </p>
                          </div>
                          <div class="text-wrapper">
                            <p class="title">
                              <span :class="newsletterType.color">NEWSLETTER</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- newletter first stage end -->
    <!-- newletter second stage start -->
    <transition name="newsletter-form-transition"
                enter-active-class="animated-subscription-box fadeInDown-subscription"
                leave-active-class="animated-subscription-box fadeOut" @enter="play1" appear>
      <div class="subscription-box w-100 h-100" v-if="submit" :class="newsletterType.color">
        <transition name="newsletter-form-transition"
                    enter-active-class="animated-subscription-box fadeInDown-subscription"
                    leave-active-class="animated-subscription-box fadeOut" appear>
          <div class="subscription first w-100 h-100" :class="newsletterType.color">
            <transition name="newsletter-form-transition"
                        enter-active-class="animated-subscription-box fadeInDown-subscription"
                        leave-active-class="animated-subscription-box fadeOut" appear>
              <div class="subscription second w-100 h-100" :class="newsletterType.color">
                <transition name="newsletter-form-transition"
                            enter-active-class="animated-subscription-box fadeInDown-subscription"
                            leave-active-class="animated-subscription-box fadeOut" appear>
                  <div class="subscription third w-100 h-100" :class="newsletterType.color">
                    <transition name="newsletter-form-transition"
                                enter-active-class="animated-subscription-box fadeInDown-subscription"
                                leave-active-class="animated-subscription-box fadeOut" appear>
                      <div class="subscription forth w-100 h-100" :class="newsletterType.color">
                        <transition name="newsletter-form-transition"
                                    enter-active-class="animated-subscription-box fadeInDown-subscription"
                                    leave-active-class="animated-subscription-box fadeOut" appear>
                          <div class="subscription fifth monster-box w-100 h-100" :class="newsletterType.color">
                            <transition name="newsletter-form-transition"
                                        enter-active-class="animated-newsletter-monster slideInDown"
                                        leave-active-class="animated-newsletter-mosnter fadeOut"
                                        @after-enter="subscriptionText = true" @after-leave="subscriptionText = false"
                                        appear>
                              <div class="monster-wrapper">
                                <div class="w-100 text-center monster">
                                  <svg-email-monster-icon class="animated-monster"></svg-email-monster-icon>
                                </div>
                                <div class="monster-email animated-email">
                                  <div class="row no-gutters justify-content-center mx-100 h-100">
                                    <div class="col-3 text-center align-self-center">
                                      <svg-email-black-icon></svg-email-black-icon>
                                    </div>
                                    <div class="col-3 text-center align-self-center">
                                      <svg-email-black-icon></svg-email-black-icon>
                                    </div>
                                    <div class="col-3 text-center align-self-center">
                                      <svg-email-black-icon></svg-email-black-icon>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </transition>
                            <div class="monster-subscription mx-auto" v-if="subscriptionText">
                              <transition :duration="500" name="monster-subscription-des1"
                                          enter-active-class="animated-newsletter-des1 fadeInDownDes1"
                                          leave-active-class="animated-newsletter-des1 fadeOut" appear @enter="play2">
                                <div class="section-type text-center" v-if="subscriptionText">THANK YOU</div>
                              </transition>
                              <transition :duration="500" name="newsletter-subscription-des2"
                                          enter-active-class="animated-newsletter-des2 fadeInDownDes2"
                                          leave-active-class="animated-newsletter-des2 fadeOut" appear>
                                <div class="subscription-text pt-2 pl-1 pr-1 mx-auto" v-if="subscriptionText">
                                  <div class="row no-gutters justify-content-center">
                                    <div class="col-11 text-center" :class="newsletterType.color">
                                      YOU ARE NOW ON THE EMAIL LIST
                                    </div>
                                  </div>
                                </div>
                              </transition>
                            </div>
                          </div>
                        </transition>
                      </div>
                    </transition>
                  </div>
                </transition>
              </div>
            </transition>
          </div>
        </transition>
      </div>
    </transition>
    <!-- newletter second stage end -->
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import { ResizeObserver } from 'vue-resize'

  import get from 'lodash/get'
  import isFunction from 'lodash/isFunction'
  import includes from 'lodash/includes'

  import SvgDiamondShapeIcon from 'static/svg/raw/enews_diamondshape.svg'
  import SvgEmailBlackIcon from 'static/svg/raw/email-black.svg'
  import SvgEmailMonsterIcon from 'static/svg/raw/email_monster.svg'
  import NewsletterMixin from 'components/mixins/newsletter'
  import { getNewsLetterMapping, isDesktop } from 'mixins/utilities'
  import GTMManager from 'mixins/gtm-manager'

  export default {
    mixins: [NewsletterMixin],
    props: {
      sections: {
        type: Array,
        default: () => [],
      },
      gtmType: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        submit: false,
        monsterEmail: '',
        warning: false,
        subscription: false,
        subscriptionText: false,
        lastInnerBox: false,
        newsletterWrapperHeight: 'auto',
      }
    },
    components: {
      SvgDiamondShapeIcon,
      SvgEmailBlackIcon,
      SvgEmailMonsterIcon,
      ResizeObserver,
    },
    computed: {
      ...mapState(['showNewsletter']),
      newsletterType() {
        return getNewsLetterMapping(this.sections) || {}
      },
      gtmNewsletterCategory() {
        return get(GTMManager.getDynamicGtmEventsByType(this.gtmType, {}), 'category', false)
      },
    },
    methods: {
      onResize() {
        // It resizes already in the begining due to the content in .newsletter-text-box > .newsletter, so no need to put on mount
        this.setNewsletterWrapperHeight()
      },
      onSubmit() {
        if (this.validateEmail(this.monsterEmail)) {
          this.warning = false
          this.submit = true
          this.subscribeNewsletter(this.monsterEmail, this.newsletterType, this.gtmNewsletterCategory)
        } else {
          this.warning = true
          this.submit = false
        }
      },
      animation(e) {
        for (let i = 0; i < 5; i += 1) {
          const classList = get(this, `$refs['innerbox-${i}'].classList`, [])
          if (isFunction(classList[e])) classList[e]('animated-inner-box')

          // Calculate height after class has been set since based on first innerbox
          if (i === 0 && includes(classList, 'animated-inner-box')) this.setNewsletterWrapperHeight()
        }
        const classList = get(this, '$refs.newsletterTextBox.classList', [])
        if (isFunction(classList[e])) classList[e]('animated-newsletter-text-box')
      },
      setNewsletterWrapperHeight() {
        // So Height is the same for the next layer (i.e. successfull sign up)
        const firstInnerbox = get(this, '$refs.innerbox-0', false)

        if (!isDesktop() && firstInnerbox) {
          const addHeightAllowance = 64
          this.newsletterWrapperHeight = `${firstInnerbox.offsetHeight + addHeightAllowance}px`
        }
      },
    },
    mounted() {
      this.checkSubscribedToList(this.newsletterType)
    },
  }
</script>
<style lang="scss" scoped>
  .newsletter-inner-wrapper {
    overflow: hidden;
    & > .innerbox {
      margin-right: -50%; // if this changes, change value in .newsletter-text-box .newsletter as well
    }
  }

  .blue {
    color: $waterspout !important;
    border-color: $waterspout !important;
  }

  .green {
    color: $jade !important;
    border-color: $jade !important;
  }

  .yellow {
    color: $banana-yellow !important;
    border-color: $banana-yellow !important;
  }

  .newsletter {
    font-family: $silkscreen;
    position: relative;
    height: auto;
    &.hidden-overflow {
      overflow: hidden;
    }

    .input-group-btn {
      flex: 0 0 100%;
    }
    .form-btn {
      width: rem-calc(115);
      border: rem-calc(4) solid $rose;
      border-left: none;

      background-color: $rose;
      display: flex;
    }

    .diamond-icon {
      position: absolute;
      z-index: 2;
      top: rem-calc(- 10);
      right: rem-calc(20);
      transform: translateZ(100px);

      svg-email-black-icon {
        z-index: 2;
        position: absolute;
        top: rem-calc(10);
        right: rem-calc(10);
      }
      &:after {
        content: url(/static/svg/raw/email-black.svg);
        position: absolute;
        left: 50%;
        margin-left: -15px;
        top: 50%;
        margin-top: -15px;
      }
    }
    .notification.warning-color {
      background: $neon-fuchsia;
      > div {
        justify-content: center;
        font-weight: bold;
        color: $white;
        font-size: rem-calc(14);
      }
    }
    input.warning-color {
      color: $neon-fuchsia;
    }
    .warning {
      div {
        font-family: $barlow;
        font-size: rem-calc(12);
        line-height: rem-calc(14);
      }
      height: rem-calc(35);
    }
    .mail-icon {
      width: rem-calc(24);
      height: rem-calc(18);
    }
    .newsletter-form {
      position: absolute;
      top: auto;
      bottom: -1px;
      left: 0;
      right: 0;
      margin: 0 auto;
      z-index: 2;
      transform: translateZ(100px);
      
      .input-email {
        font-family: $barlow;
        font-size: rem-calc(24);
        border-radius: unset;
        border-bottom: 3px solid $manatee;
        &::-webkit-input-placeholder {
          /* Chrome/Opera/Safari */
          color: $pastel-gray;
          padding-left: rem-calc(8);
        }
        &::-moz-placeholder {
          /* Firefox 19+ */
          color: $pastel-gray;
          padding-left: rem-calc(8);
        }
        &:-ms-input-placeholder {
          /* IE 10+ */
          color: $pastel-gray;
          padding-left: rem-calc(8);
        }
        &:-moz-placeholder {
          /* Firefox 18- */
          color: $pastel-gray;
          padding-left: rem-calc(8);
        }
      }
      .form-input {
        border: rem-calc(4) solid $rose;
        border-right: none;
        background-color: $rose;
        transition: all 0.2s ease-in-out;
      }
      .form-btn {
        width: rem-calc(115);
        border: rem-calc(4) solid $rose;
        border-left: none;
        transition: all 0.2s ease-in-out;
      }
      input {
        caret-color: $rose;
        outline-width: 2px;
        height: rem-calc(45);
      }
      .submit-newsletter {
        height: rem-calc(45);
        font-family: $barlow;
        background: $rose;
        border-radius: unset;
        color: $white;
        font-size: rem-calc(18);
        padding-left: rem-calc(42);
        padding-right: rem-calc(42);
        &:focus {
          box-shadow: none;
        }
        span {
          font-size: rem-calc(20);
          color: $white;
          font-family: $silkscreen;
        }
      }
    }
    &.innerbox-black {
      background: $black;
    }
    .section-type {
      font-weight: bold;
      font-size: rem-calc(28);
      line-height: rem-calc(28);
      text-shadow: rem-calc(2) rem-calc(2) rem-calc(0) $rose;
      @include respond-to('desktop') {
        font-size: rem-calc(32);
        line-height: rem-calc(32);
      }
    }
    .newsletter-text-box {
      z-index: 2;
      position: relative;
      .newsletter {
        padding: 0;
        height: auto;
        margin-right: 29%; // due to .innerbox negative margin

        p.title {
          color: $rose;
          font-size: rem-calc(20);
          line-height: rem-calc(30);
          &.brand-title {
            font-size: rem-calc(24);
            line-height: 1;
            font-family: $font-04b03;
            margin-left: rem-calc(4);
          }
          &:first-child {
            margin-top: rem-calc(5);
            margin-bottom: rem-calc(5);
          }
        }
        p span {
          color: $waterspout;
        }
      }
      .newsletter-text-content-wrapper {
        .text-wrapper {
          transform: translate3d(100%, 0, 0);
          margin: 0;
        }
      }
    }
    .animated-newsletter-text-box {
      animation-duration: 500ms;

      .newsletter-text-content-wrapper {
        .text-wrapper {
          margin-left: rem-calc(10);
          animation: slideInRight .3s ease-in-out;
          animation-fill-mode: both;

          // Need to be separated so next translate3d will be applied due to different timings
          p {
            animation: bounce-in .6s ease-in-out;
            animation-fill-mode: both;
          }

          $elements: 3;
          $parent-delay: .3s;
          $child-delay: .5s;
          @for $i from 1 through $elements {
            &:nth-child(#{$i}) {
               animation-delay: $parent-delay;
               $parent-delay: $parent-delay + .2;
              p {
                animation-delay: $child-delay;
                $child-delay: $child-delay + .2;
              }
            }
          }
        }
      }
    }

    .innerbox {
      transform: scale(0, 0);
      opacity: 0;
      border-style: solid;
      border-color: $waterspout;
      animation-delay: 0s;
      padding: rem-calc(10);
      transition: transform .4s,
      opacity .4s;
      transition-timing-function: ease-in-out;
      animation-fill-mode: both;

      &.first {
        margin-left: 100%;
        transition-delay: 0s;
        border-width: rem-calc(6);
      }
      &.second {
        transition-delay: .1s;
        border-width: rem-calc(4);
        animation-delay: 1s;
      }
      &.third {
        transition-delay: .2s;
        border-width: rem-calc(3);
        animation-delay: 2s;
      }
      &.forth {
        transition-delay: .3s;
        border-width: rem-calc(2);
        position: relative;
        animation-delay: 3s;
      }
      &.fifth {
        transition-delay: .4s;
        padding: rem-calc(2.5 0);
        border-width: rem-calc(1);
        animation-delay: 4s;
      }
    }

    .subscription-box {
      .subscription {
        padding-bottom: rem-calc(6);
        border-style: solid;
        border-color: $waterspout;
        padding-bottom: rem-calc(10);

        &.first {
          border-width: rem-calc(0 0 5);
        }
        &.second {
          border-width: rem-calc(0 0 4);
        }
        &.third {
          border-width: rem-calc(0 0 3);
        }
        &.forth {
          border-width: rem-calc(0 0 2);
        }
        &.fifth {
          border-width: rem-calc(0 0 1);
          position: relative;
          svg {
            margin-top: rem-calc(-1);
          }
          .monster-email {
            margin-left: auto;
            margin-right: auto;
            left: 0;
            right: 0;
            width: rem-calc(303);
            height: rem-calc(113);
            position: absolute;
            top: -9px;
            z-index: 2;
          }
          .monster-subscription {
            padding-top: rem-calc(8);
            width: rem-calc(237);
            .section-type {
              font-size: rem-calc(32);
              font-weight: bold;
              line-height: rem-calc(27);
            }
            .subscription-text {
              color: $waterspout;
              font-size: rem-calc(20);
              line-height: rem-calc(22);
            }
          }
        }
      }
    }
    // transition effect
    .animated-submit-form {
      animation-duration: .5s;
      animation-fill-mode: both;
      animation-delay: 1.5s;
    }
    .animated-newsletter-des1 {
      animation-duration: .8s;
      animation-fill-mode: both;
    }
    .animated-newsletter-des2 {
      animation-duration: .5s;
      animation-fill-mode: both;
    }
    .animated-subscription-box {
      animation-fill-mode: both;
      &.first {
        animation-duration: 400ms;
        animation-delay: 0ms;
      }
      &.second {
        animation-duration: 400ms;
        animation-delay: 150ms;
      }
      &.third {
        animation-duration: 400ms;
        animation-delay: 200ms;
      }
      &.forth {
        animation-duration: 400ms;
        animation-delay: 250ms;
      }
      &.fifth {
        animation-duration: 400ms;
        animation-delay: 300ms;
      }

    }
    .animated-newsletter-monster {
      animation-duration: 1000ms;
      animation-fill-mode: both;
      animation-delay: 800ms;
      animation-timing-function: ease;
    }
    .animated-inner-box {
      animation-duration: 500ms;
      transform: scale(1, 1);
      opacity: 1;
      &.first {
        margin-left: 0;
      }
    }
    .animated-monster {
      animation: move 15s steps(2) infinite alternate;
      animation-fill-mode: both;
      animation-name: monster-shake;
    }
    .animated-email {
      animation: move 15s steps(2) infinite alternate;
      animation-fill-mode: both;
      animation-name: email-shake;
    }
    .fadeInDownDes1 {
      animation-name: fadeInDownDes1;
    }
    .fadeInDownDes2 {
      animation-name: fadeInDownDes2;
    }
    .fadeInDown-subscription {
      animation-timing-function: cubic-bezier( .6,0,.23,1 );
      animation-name: fadeInDown-subscription;
    }

    @keyframes bounce-in {
      0% {
        transform: translate3d(-8px, 0, 0);
      }
      100% {
        transform: translate3d(0, 0, 0);
      }
    }

    @keyframes monster-shake {
      from,
      to {
        transform: translate3d(0, 0, 0);
      }

      10%,
      30%,
      50%,
      70%,
      90% {
        transform: translate3d(-7px, 0, 0);
      }

      20%,
      40%,
      60%,
      80% {
        transform: translate3d(7px, 0, 0);
      }
    }

    @keyframes email-shake {
      from,
      to {
        transform: translate3d(0, 0, 0);
      }

      10%,
      30%,
      50%,
      70%,
      90% {
        transform: translate3d(5px, 0, 0);
      }

      20%,
      40%,
      60%,
      80% {
        transform: translate3d(-5px, 0, 0);
      }
    }

    @keyframes fadeInDownDes1 {
      from {
        opacity: 0;
        transform: translate3d(-10px, -100%, 0);
      }
      to {
        opacity: 1;
        transform: none;
      }
    }

    @keyframes fadeInDownDes2 {
      from {
        opacity: 0;
        transform: translate3d(10px, -120%, 0);
      }

      to {
        opacity: 1;
        transform: none;
      }
    }

    @keyframes fadeInDown-subscription {
      from {
        opacity: 0;
        transform: translate3d(0, -100%, 0);
      }
      to {
        opacity: 1;
        transform: none;
      }
    }
  }

  .newsletter-form .justify-content-center:hover {
    .form-input, .form-btn {
      border-color: $jazzberry-jam;
    }
    .form-btn button {
      background: $jazzberry-jam;
    }
  }
</style>



// WEBPACK FOOTER //
// MonsterNewsletterForm.vue?5c27108d